import React from 'react';
import { ProjectRow } from './ProjectRow';
import type { Lang, LocaleContent } from '../types/profile';
interface ProjectsSectionProps {
  lang: Lang;
  content: LocaleContent;
}
export function ProjectsSection({
  lang,
  content
}: ProjectsSectionProps) {
  const isThai = lang === 'th';
  return <section id="projects" aria-labelledby="projects-heading" className="scroll-mt-28 pb-16 pt-8 sm:pb-24" data-id="element-122" data-mp="1kd7hsmfdj5fd">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-123" data-mp="mqqnlq1xt7xu">
        <div className="flex flex-col gap-6 pb-10 sm:flex-row sm:items-end sm:justify-between sm:pb-14" data-id="element-124" data-mp="rnqs3wj522mu">
          <div data-id="element-125" data-mp="wmtvzdndu2t8">
            <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-sage-deep" data-id="element-126" data-mp="wmbrjtqkgia8">
              02 — {content.projectsLabel}
            </p>
            <h2 id="projects-heading" className={`mt-4 max-w-2xl font-display font-light text-charcoal ${isThai ? 'text-[2rem] leading-[1.45] sm:text-[2.75rem]' : 'text-[2.25rem] leading-[1.05] tracking-[-0.02em] sm:text-[3.25rem]'}`} data-id="element-127" data-mp="11k3o5125oskr">
              {content.projectsHeading}
            </h2>
          </div>
          <span aria-hidden="true" className="decor font-display text-[1.25rem] italic text-ink-soft" data-id="element-128" data-mp="30y44p8zorpan">
            {String(content.projects.length).padStart(2, '0')}
          </span>
        </div>

        <ol className="border-b border-line" data-id="element-129" data-mp="2r0yd7zn5tw9w">
          {content.projects.map((project, i) => <ProjectRow key={project.id} project={project} index={i} lang={lang} data-id="element-130" data-mp="2m8of3wbw5pwj" data-mpi={i} />)}
        </ol>
      </div>
    </section>;
}